import { graphql } from '@/generated/gql';

export const NEGOTIATION_TASKS_QUERY = graphql(/* GraphQL */ `
  query NegotiationTasks($offset: Int, $limit: Int, $where: TasksFilterInput) {
    tasks(limit: $limit, offset: $offset, where: $where) {
      nodes {
        id
        message {
          variant
          details
        }
        status
        variant
        relatedResources {
          project
          reference
          variant
        }
      }
      totalCount
    }
  }
`);
